<div style="display: flex; background-color: #fff; border-bottom: 1px solid #bdbdbd">
  <div style="flex-grow: 1; margin-left: 10px">
    <h1>User Profile</h1>
  </div>
  <div style="flex-shrink: 1; margin-top: auto; margin-bottom: auto; margin-right: 10px">
    <button
      type="button"
      class="blue-btn"
      pButton
      (click)="grabMovement()"
      label="Grab Job &#8594;"
    ></button>
  </div>
</div>
